import gsap from 'gsap';
import whatInput from 'what-input';

const selectors = {
  el: '.js-pamplemousse:not(.is-initialized)',
};

const pamplemousseXTransforms = [
  {
    skewX: 5,
  },
  {
    skewX: 0,
  },
  {
    skewX: -5,
  },
];

const pamplemousseYTransforms = [
  {
    scaleY: 1.05,
  },
  {
    scaleY: 1,
  },
  {
    scaleY: 0.95,
  },
];

const eyesXTransforms = [
  {
    rotationY: -25,
    x: '-22%',
  },
  {
    rotationY: 0,
    x: '0%',
  },
  {
    rotationY: 25,
    x: '17%',
  },
];

const eyesYTransforms = [
  {
    rotationX: 10,
    y: '-7%',
  },
  {
    rotationX: 0,
    y: '0%',
  },
  {
    rotationX: -10,
    y: '7%',
  },
];

const mouthXTransforms = [
  {
    rotationY: -15,
    x: '-22%',
  },
  {
    rotationY: 0,
    x: 0,
  },
  {
    rotationY: 15,
    x: '17%',
  },
];

const mouthYTransforms = [
  {
    rotationX: 25,
    y: '-7%',
  },
  {
    rotationX: 0,
    y: '0%',
  },
  {
    rotationX: -20,
    y: '5%',
  },
];

const init = () => {
  const els = document.querySelectorAll(selectors.el);

  els.forEach(el => {
    el.classList.add('is-initialized');
  
    const pamplemousse = el.querySelector('#pamplemousse');
    const eyes = el.querySelector('#eyes');
    const mouth = el.querySelector('#mouth');
  
    gsap.set(pamplemousse, {
      transformOrigin: 'bottom left',
    });
  
    gsap.set(eyes, {
      transformPerspective: 400,
      transformStyle: 'preserve-3d',
    });
  
    gsap.set(mouth, {
      transformPerspective: 400,
      transformStyle: 'preserve-3d',
    });
  
    const pamplemousseXTl = gsap.timeline({ paused: true });
  
    const pamplemousseYTl = gsap.timeline({ paused: true });
  
    const eyesXTl = gsap.timeline({ paused: true });
  
    const eyesYTl = gsap.timeline({ paused: true });
  
    const eyesBlinkTl = gsap.timeline({
      repeat: -1,
    });
    eyesBlinkTl
      .to(
        eyes,
        {
          scaleY: 0,
          duration: 0.05,
          transformOrigin: '50% 35%',
        },
        '+=5',
      )
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      })
      .to(
        eyes,
        {
          scaleY: 0,
          duration: 0.05,
          transformOrigin: '50% 35%',
        },
        '+=5',
      )
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      })
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      })
      .to(
        eyes,
        {
          scaleY: 0,
          duration: 0.05,
          transformOrigin: '50% 35%',
        },
        '+=5',
      )
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      })
      .to(
        eyes,
        {
          scaleY: 0,
          duration: 0.05,
          transformOrigin: '50% 35%',
        },
        '+=.1',
      )
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      });
  
    const mouthXTl = gsap.timeline({ paused: true });
  
    const mouthYTl = gsap.timeline({ paused: true });
  
    pamplemousseXTransforms.forEach(t => {
      pamplemousseXTl.to(
        pamplemousse,
        Object.assign(
          {
            duration: 1,
            ease: 'none',
          },
          t,
        ),
      );
    });
  
    pamplemousseYTransforms.forEach(t => {
      pamplemousseYTl.to(
        pamplemousse,
        Object.assign(
          {
            duration: 1,
            ease: 'none',
          },
          t,
        ),
      );
    });
  
    eyesXTransforms.forEach(t => {
      eyesXTl.to(
        eyes,
        Object.assign(
          {
            duration: 1,
            ease: 'none',
          },
          t,
        ),
      );
    });
  
    eyesYTransforms.forEach(t => {
      eyesYTl.to(
        eyes,
        Object.assign(
          {
            duration: 1,
            ease: 'none',
          },
          t,
        ),
      );
    });
  
    mouthXTransforms.forEach(t => {
      mouthXTl.to(
        mouth,
        Object.assign(
          {
            duration: 1,
            ease: 'none',
          },
          t,
        ),
      );
    });
  
    mouthYTransforms.forEach(t => {
      mouthYTl.to(
        mouth,
        Object.assign(
          {
            duration: 1,
            ease: 'none',
          },
          t,
        ),
      );
    });
  
    window.addEventListener('mousemove', e => {
      if (whatInput.ask() === 'touch') return;
      const x = e.clientX / window.innerWidth + parseFloat(el.dataset.lookXOffset);
      const y = e.clientY / window.innerHeight + parseFloat(el.dataset.lookYOffset);
      pamplemousseXTl.seek(x * 2 + 1);
      pamplemousseYTl.seek(y * 2 + 1);
      eyesXTl.seek(x * 2 + 1);
      eyesYTl.seek(y * 2 + 1);
      mouthXTl.seek(x * 2 + 1);
      mouthYTl.seek(y * 2 + 1);
    });
  
    window.addEventListener('resize', () => {
      if (whatInput.ask() === 'touch') return;
      pamplemousseXTl.invalidate();
      pamplemousseYTl.invalidate();
      eyesXTl.invalidate();
      eyesYTl.invalidate();
      mouthXTl.invalidate();
      mouthYTl.invalidate();
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
